import axios, { AxiosRequestConfig } from "axios";
import router from "@/router";

import auth from "./auth";
import Paciente from "./paciente";
import PacienteProntuario from "./pacienteProntuario";
import Perfil from "./perfil";
import Relatorio from "./relatorio";
import Dinamico from "./dinamico";
import Config from "./config";
import Agenda from "./agenda";
import AgendaSala from "./AgendaSalaService";
import AgendaProcedimento from "./agendaProcedimento";
import Atendimento from "./atendimento";
import AtendimentoProcedimento from "./atendProcedimentos";
import Convenio from "./convenio";
import PacienteConvenio from "./pacienteConvenio";
import Procedimento from "./procedimento";
import TipoAtend from "./tipoAtend";
import Profissional from "./profissional";
import configuracoes from '@/config/config.json';

import { baseUrlDorape } from "@/consts/consts";
import { store } from "@/store";

const API_ENVS = {
    production: '',
    development: '',
    local: baseUrlDorape().then(url => url)
};

const httpClient = axios.create();
const token = String(sessionStorage.getItem('TokenProntuarioWeb'));

// httpClient.defaults.baseURL = "https://localhost:7202/api";
// httpClient.defaults.baseURL = "https://prontuarioapi.agape-sistemas.com/api";
// httpClient.defaults.baseURL = "https://Ortopediaapi.agape-sistemas.com/api";
// httpClient.defaults.baseURL = "https://cdhapi.agape-sistemas.com/api";
httpClient.defaults.baseURL = configuracoes.api;

// baseUrlDorape()
//     .then((url) => {
//          httpClient.defaults.baseURL = url;
// });

//@ts-expect-error:un
httpClient.interceptors.request.use((config: AxiosRequestConfig) => {
    if (config.headers == undefined)
        config.headers = {};

    config.headers.Authorization = `Bearer ${token}`;
    return config;
});

httpClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const canThrowAnError = error.request.status === 0 || error.request.status === 5000;
        if (canThrowAnError) {
            throw new Error(error.message);
        }

        if (error.response.status === 401) {
            (token) ? router.push({ name: 'Home' }) : router.push({ name: 'Login' });
        }
        return error;
    });

export default {
    auth: auth(httpClient),
    paciente: Paciente(httpClient),
    pacienteProntuario: PacienteProntuario(httpClient),
    perfil: Perfil(httpClient),
    relatorio: Relatorio(httpClient),
    dinamico: Dinamico(httpClient),
    config: Config(httpClient),
    agenda: Agenda(httpClient),
    agendaProcedimento: AgendaProcedimento(httpClient),
    atendimento: Atendimento(httpClient),
    atendProcedimento: AtendimentoProcedimento(httpClient),
    convenio: Convenio(httpClient),
    pacienteConvenio: PacienteConvenio(httpClient),
    procedimento: Procedimento(httpClient),
    tipoAtend: TipoAtend(httpClient),
    profissional: Profissional(httpClient),
    AgendaSalaService: AgendaSala(httpClient),
};